var VideoListing = {
    id: '#videoModal',
    hideModal = function () {
        var closeBtn = $('.video-close');
        var modal = $(this.id);

        closeBtn.on('click', function (e) {
            e.preventDefault();

            // clear video src
            var src = $(this).parents('.ze-video-modal').find('source');
            src.attr('src', '');

            // allow scrolling
            $('body').css('overflow-y', 'auto');

            // hide modal
            modal.hide();
        });
    },
    showModal = function () {
        var playBtns = $('.video-play');
        var modal = $(this.id);

        playBtns.on('click', function (e) {
            e.preventDefault();

            // add video url
            var url = $(this).data('video-url');
            modal.find('source').attr('src', url);

            modal.find('video')[0].load();

            // prevent scrolling
            $('body').css("overflow-y", "hidden");

            // show modal
            modal.show();
        });
    },
    eventListeners = function () {
        this.showModal();
        this.hideModal();
    },
    init: function () {
        this.eventListeners();
    }
};